import config from "../config";

const resourceMap = 
config.TITLE === "Telestroke" ? {
    home: {
      title: "Telestroke",
      path: "/",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      desc: "<p>Telestroke is a 24/7 emergency telemedicine application that provides emergency physicians with immediate access to neurologists with expertise in stroke care who can support both the assessment and treatment of patients experiencing acute stroke.</p><p>A Telestroke Referring Site Handbook has been developed to provide a concise introduction to the Provincial Telestroke program for new and existing referring sites. The contents and resources in the Toolkit have been pulled from current Telestroke sites, the Ontario Stroke System and the Ontario Telemedicine Network.</p><p>This Handbook includes workflows, processes, tools, and resources that can be adapted and integrated within your organization's existing policies and procedures. Using this Handbook, you will be able to provide a standardized, province-wide infrastructure that supports a Telestroke encounter. All comments or suggestions for improvement are welcome.</p>",
      sections: [
        {
          title: "",
          format: "portal",
          content: [
            {
              format: "card",
              flex: false,
              access: config.cognito.SUB1_SUB,
              label: "Resources for Telestroke Neurologists",
              desc: "<p>Forms, OHIP information, schedules, and other documents</p>",
              source: "/consultant",
            },
            {
              format: "card",
              flex: false,
              access: config.cognito.SUB2_SUB,
              label: "Telestroke Site Information",
              desc: "<p>Forms, site information and workflows</p>",
              source: "/referrer",
            },
          ],
        },
        {
          title: "Getting Started",
          content: [
            {
              label: "Telestroke Referring Site Application (EN)",
              format: "pdf",
              source:
                "/resources/public/telestroke-referring-site-application.pdf",
            },
            {
              label: "Telestroke Referring Site Application (FR)",
              format: "pdf",
              source:
                "/resources/public/telestroke-referring-site-application-fr.pdf",
            },
            {
              label: "Becoming a Telestroke Neurologist (EN)",
              format: "pdf",
              source: "/resources/public/otn-telestroke-one-pager.pdf",
            },
            {
              label: "Becoming a Telestroke Neurologist (FR)",
              format: "pdf",
              source: "/resources/public/otn-telestroke-one-pager-fr.pdf",
            },
            {
              label: "Telestroke Referring Site Handbook (EN)",
              format: "pdf",
              source: "/resources/public/telestroke-referring-site-handbook.pdf",
            },
            {
              label: "Telestroke Referring Site Handbook (FR)",
              format: "pdf",
              source: "/resources/public/telestroke-referring-site-handbook-fr.pdf",
            },
            {
              label: "Telestroke Referral Worksheet (EN)",
              format: "pdf",
              source: "/resources/public/telestroke-referral-worksheet.pdf",
            },
            {
              label: "Telestroke Referral Worksheet (FR)",
              format: "pdf",
              source: "/resources/public/telestroke-referral-worksheet-fr.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (EN)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (FR)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm-fr.pdf",
            },
            {
              format: "spacer",
              height: "2em",
            },
            {
              format: "youtubeembed",
              source: "JU0RIvq4XFA",
            },
          ],
        },
        {
          title: "Brochures",
          content: [
            {
              label: "Telestroke Patient (EN)",
              format: "pdf",
              source: "/resources/public/otn-telestroke-brochure-EN.pdf",
            },
            {
              label: "Telestroke Patient (FR)",
              format: "pdf",
              source: "/resources/public/otn-telestroke-brochure-fr.pdf",
            },
            {
              label: "Patient Family Education Pamphlet on EVT",
              format: "pdf",
              source:
                "http://ontariostrokenetwork.ca/evtstaging/wp-content/uploads/sites/10/2016/08/Patient-Family-Education-Pamphlet-on-EVT.pdf",
            },
          ],
        },
      ],
    },
    sub1: {
      title: "Resources for Telestroke Neurologists",
      path: "/consultant",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      access: config.cognito.SUB1_SUB,
      sections: [
        {
          title: "Telestroke Consultant / Forms",
          content: [
            {
              label: "*New* Save time by using pre-populated consult notes",
              format: "routerlink",
              source: "/consultnotes",
            },
            {
              label: "Billing Information for Telestroke Consultants",
              format: "pdf",
              access: "shared",
              source: "otn-telestroke-billing-information.pdf",
            },
            {
              label: "Consult Note",
              format: "pdf",
              source: "otn-telestroke-consult-note_0.pdf",
            },
            {
              label: "Telephone Advice Note",
              format: "pdf",
              source: "otn-telestroke-telephone-advice_002.pdf",
            },
            {
              label: "Consultant Feedback Form",
              format: "pdf",
              source: "otn-telestroke-feedback-neuro.pdf",
            },
            {
              label: "Follow-up Note",
              format: "pdf",
              source: "otn-telestroke-follow-up-note.pdf",
            },
            {
              label: "Hospital Telephone & Fax",
              access: "shared",
              format: "pdf",
              source: "otn-telestroke-hospital-telephone-fax.pdf",
            },
            {
              label: "EVT Centre Emergency Department Telephone & Fax",
              format: "pdf",
              source:
                "evt_centre_emergency_department_telephone_fax_july_2021.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (EN)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (FR)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm-fr.pdf",
            }
          ],
        },
        /*YB removed 2022-11-29 as per OVCP change requests
        {
          title: "Telestroke Consultant / OHIP Information",
          content: [
            {
              label: "TM Billing Info Manual",
              format: "pdf",
              source: "ohip_telemedicine_billing_information_manual.pdf",
            },
            {
              label: "OHIP Virtual Care Physician & Dentist Registration Form",
              format: "pdf",
              source: "ohip_virtual_care_physician_registration_form.pdf",
            },
          ],
        },
        End removal */
        {
          title: "Telestroke Consultant / On-call schedule",
          content: [
            {
              label: "On Call Schedule",
              format: "pdf",
              source: "Ontario Telestroke Program On Call Schedule.pdf"
            }
          ],
        },
        {
          title: "Telestroke Consultant / Reference Documents",
          content: [
            {
              label: "Tenecteplase (TNK) Site List",
              format: "pdf",
              source: "Tenecteplase Site List.pdf",
            },
            {
              label: "TNK Safety Memo",
              format: "pdf",
              source: "TNK Saftey Memo _FINAL (005).pdf",
            },
            {
              label: "OTP Documentation Policy",
              format: "pdf",
              source: "otp_documentation_policymay_2021_final.pdf",
            },
            {
              label:
                "New Process for Reporting & Monitoring Inappropriate Referrals",
              format: "pdf",
              source:
                "new_process_for_reporting_monitoring_telestroke_feedback.pdf",
            },
            {
              label: "Telestroke Consulting Physician Handbook (EN)",
              format: "pdf",
              source: "otn-telestroke-handbook-consulting-physician.pdf",
            },
            {
              label: "Telestroke Consulting Physician Handbook (FR)",
              format: "pdf",
              source: "otn-telestroke-handbook-consulting-physician-fr.pdf",
            },
            {
              label: "Clinical Process Flow",
              format: "pdf",
              source: "overall_telestroke_clinical_process_flow.pdf",
            },
            {
              label: "Consulting physician eligibility documentation",
              format: "doc",
              source:
                "otn-telestroke-consulting-physician-eligibility-documentation.doc",
            },
          ],
        },
        {
          title: "Telestroke / Consultant / Reference Documents - ENITS",
          content: [
            {
              label: "ENITS for Telestroke",
              format: "pdf",
              source: "enits_for_telestroke_0.pdf",
            },
          ],
        },
        {
          title:
            "Telestroke / Consultant / Reference Documents - Videoconferencing",
          content: [
            {
              label: "Using VidyoConnect with a Windows or Mac Computer",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-pc-mac.pdf",
            },
            {
              label: "Utilisation de VidyoConnect avec un ordinateur Windows ou Mac",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-pc-mac-fr.pdf",
            },
            {
              label: "Using VidyoConnect with a Mobile Device",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-mobile.pdf",
            },
            {
              label: "Utilisation de VidyoConnect avec un appareil mobile",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-mobile-fr.pdf",
            },
            {
              label: "Technical Readiness: Firewall Openings",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-tech-ready.pdf",
            },
            {
              label: "État de préparation technique",
              format: "pdf",
              access: "public",
              source: "https://dropbox.otn.ca/teletrauma/vidyoconn-tech-ready-fr.pdf",
            },
            {
              label: "Telestroke Referring Sites for PCVC Favourites",
              format: "pdf",
              source: "telestroke_referring_sites_for_favourites_0_0.pdf",
            },
          ],
        },
      ],
    },
    sub2: {
      title: "Telestroke Site Information",
      path: "/referrer",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      access: config.cognito.SUB2_SUB,
      sections: [
        {
          title: "Telestroke Forms",
          content: [
            {
              label: "Hospital Telephone & Fax",
              access: "shared",
              format: "pdf",
              source: "otn-telestroke-hospital-telephone-fax.pdf",
            },
            {
              label: "Billing Information for Telestroke Consultants",
              format: "pdf",
              access: "shared",
              source: "otn-telestroke-billing-information.pdf",
            },
            {
              label: "Telestroke Referral Worksheet (EN)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-referral-worksheet.pdf",
            },
            {
              label: "Telestroke Referral Worksheet (FR)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-referral-worksheet-fr.pdf",
            },
            {
              label: "Referring Site Feedback Form",
              format: "pdf",
              source: "otn-telestroke-feedback-refsite.pdf",
            }
          ],
        },
        {
          title: "Telestroke Site Info / Workflows",
          content: [
            {
              label: "New Referring Telestroke Site Workflow",
              format: "pdf",
              source: "otn-telestroke-referring-site-implementation-workflow.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (EN)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm.pdf",
            },
            {
              label: "Telestroke Referral Algorithm (FR)",
              format: "pdf",
              access: "public",
              source: "/resources/public/telestroke-algorithm-fr.pdf",
            },
            {
              label: "Telestroke Implementation Guide Sample",
              format: "xlsx",
              source: "otn-telestroke-implementation-guide.xlsx",
            },
            {
              label: "Telestroke Referring Sites Care Delivery Models",
              format: "pdf",
              source: "otn-telestroke-referring-sites-models.pdf",
            },
            {
              label: "Mock Checklist",
              format: "xlsx",
              source: "otn-telestroke-mock-checklist.xlsx",
            },
          ],
        },
      ],
    },
    consultnotes: {
      title: "Telestroke Pre-Populated Consult Notes",
      path: "/consultnotes",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      access: config.cognito.SUB1_SUB,
      sections: [
        {
          title: "Telestroke Pre-Populated Consult Notes",
          content: [
            {
              label: "Ajax",
              format: "pdf",
              source: "consultnotes/ajax-telestroke-consult-note.pdf",
            },
            {
              label: "Barrie",
              format: "pdf",
              source: "consultnotes/barrie-telestroke-consult-note.pdf",
            },
            {
              label: "Belleville",
              format: "pdf",
              source: "consultnotes/belleville-telestroke-consult-note.pdf",
            },
            {
              label: "Brampton",
              format: "pdf",
              source: "consultnotes/brampton-telestroke-consult-note.pdf",
            },
            {
              label: "Brantford",
              format: "pdf",
              source: "consultnotes/brantford-telestroke-consult-note.pdf",
            },
            {
              label: "Burlington",
              format: "pdf",
              source: "consultnotes/burlington-telestroke-consult-note.pdf",
            },
            {
              label: "Chatham",
              format: "pdf",
              source: "consultnotes/chatham-telestroke-consult-note.pdf",
            },
            {
              label: "Cornwall",
              format: "pdf",
              source: "consultnotes/cornwall-telestroke-consult-note.pdf",
            },
            {
              label: "Dryden",
              format: "pdf",
              source: "consultnotes/dryden-telestroke-consult-note.pdf",
            },
            {
              label: "Etobicoke",
              format: "pdf",
              source: "consultnotes/etobicoke-telestroke-consult-note.pdf",
            },
            {
              label: "Fort Frances",
              format: "pdf",
              source: "consultnotes/fort-frances-telestroke-consult-note.pdf",
            },
            {
              label: "Goderich",
              format: "pdf",
              source: "consultnotes/goderich-telestroke-consult-note.pdf",
            },
            {
              label: "Guelph",
              format: "pdf",
              source: "consultnotes/guelph-telestroke-consult-note.pdf",
            },
            {
              label: "Hawkesbury",
              format: "pdf",
              source: "consultnotes/hawkesbury-telestroke-consult-note.pdf",
            },
            {
              label: "Hearst",
              format: "pdf",
              source: "consultnotes/hearst-telestroke-consult-note.pdf",
            },
            {
              label: "Kenora",
              format: "pdf",
              source: "consultnotes/kenora-telestroke-consult-note.pdf",
            },
            {
              label: "Kitchener",
              format: "pdf",
              source: "consultnotes/kitchener-telestroke-consult-note.pdf",
            },
            {
              label: "Mackenzie",
              format: "pdf",
              source: "consultnotes/mackenzie-telestroke-consult-note.pdf",
            },
            {
              label: "New Liskeard",
              format: "pdf",
              source: "consultnotes/newliskeard-telestroke-consult-note.pdf",
            },
            {
              label: "Niagara",
              format: "pdf",
              source: "consultnotes/niagara-telestroke-consult-note.pdf",
            },
            {
              label: "North Bay",
              format: "pdf",
              source: "consultnotes/northbay-telestroke-consult-note.pdf",
            },
            {
              label: "Oshawa",
              format: "pdf",
              source: "consultnotes/oshawa-telestroke-consult-note.pdf",
            },
            {
              label: "Owen Sound",
              format: "pdf",
              source: "consultnotes/owen-sound-telestroke-consult-note.pdf",
            },
            {
              label: "Pembroke",
              format: "pdf",
              source: "consultnotes/pembroke-telestroke-consult-note.pdf",
            },
            {
              label: "Peterborough",
              format: "pdf",
              source: "consultnotes/peterborough-telestroke-consult-note.pdf",
            },
            {
              label: "Sarnia",
              format: "pdf",
              source: "consultnotes/sarnia-telestroke-consult-note.pdf",
            },
            {
              label: "Sault Ste. Marie",
              format: "pdf",
              source: "consultnotes/ssm-telestroke-consult-note.pdf",
            },
            {
              label: "Sioux Lookout",
              format: "pdf",
              source: "consultnotes/sioux_lookout-telestroke-consult-note.pdf",
            },
            {
              label: "Stratford",
              format: "pdf",
              source: "consultnotes/stratford-telestroke-consult-note.pdf",
            },
            {
              label: "Sudbury",
              format: "pdf",
              source: "consultnotes/sudbury-telestroke-consult-note.pdf",
            },
            {
              label: "Timmins",
              format: "pdf",
              source: "consultnotes/timmins-telestroke-consult-note.pdf",
            },
          ],
        },
      ],
    },
  }
  :
  config.TITLE === "ED P2P" ? {
    home: {
      title: "ED Peer-to-Peer Program",
      path: "/",
      format: "bucket",
      background: "/img/edpeer-heroimg.jpg",
      desc: "<p>Welcome to The Emergency Department (ED) Peer-to-Peer Program Member Login Site supporting hospital site implementation and ED Peer Physicians!</p><p>The ED Peer-to-Peer Program has been established in Ontario to provide critical support for physicians in rural hospitals who are meeting challenges in delivery of patient care.</p><p>The ED Peer-to-Peer Program will provide a straight-forward way to directly support physicians, 24/7 for all CTAS levels, increasing their comfort in staffing rural and remote Ontario EDs. The Program will be implemented by Ontario Health in a phased approach focusing on sites that have the highest need in terms of physician shortages, remoteness and lack of primary and community health care supports, particularly in the Ontario Health North region.</p><p>The Program leverages the established CritiCall and Ontario Health (OTN) platforms to support all patient acuity levels and offer immediate access to a member of a team of highly qualified emergency physicians. When accessing the Program, site physicians will receive on-demand, real-time coaching and support from a peer ED physician.</p><p>Please contact <a href=\"mailto:EDPeer@ontariohealth.ca\">EDPeer@ontariohealth.ca</a> if you have any questions.</p>",
      sections: [
        {
          title: "",
          format: "portal",
          content: [
            {
              format: "card",
              flex: true,
              access: config.cognito.SUB1_SUB,
              label: "ED Site",
              desc: "<p>For implementation of the ED Peer-to-Peer program at your hospital</p>",
              source: "/edsite",
            },
            {
              format: "card",
              flex: true,
              access: config.cognito.SUB2_SUB,
              label: "ED Peer",
              desc: "<p>For ED Peers participating in the ED Peer-to-Peer program</p>",
              source: "/edpeer",
            },
            {
              format: "card",
              flex: true,
              access: [config.cognito.SUB1_SUB,config.cognito.SUB2_SUB],
              label: "Resource Library",
              desc: "<p>Helpful resources for both rural EDs and ED Peers participating in the ED Peer-to-Peer program</p>",
              source: "/resources",
            },
          ],
        },
      ],
    },
    sub1: {
      title: "Resources for ED Peer-to-Peer Hospital Site Implementation",
      shorttitle: "Hospital Site Implementation",
      breadcrumb: "<a href="+config.apiGateway.URL+"}></a> > ED Site",
      path: "/edsite",
      format: "bucket",
      background: "/img/edpeer-heroimg.jpg",
      access: config.cognito.SUB1_SUB,
      sections: [
        {
          title: "Project Overview",
          content: [
            {
              label: "Phase 2 Implementation Calendar",
              format: "pdf",
              source: "OH_EDPeer_Phase 2 Implementation Calendar.pdf",
            },
            {
              label: "Phase 2 High Level Timeline",
              format: "pdf",
              source: "ED Peer-to-Peer Program Phase 2 Implementation High Level Timeline.pdf",
            },
            {
              format: "spacer",
              height: "1em"
            },
            {
              label: "Phase 1 High Level Implementation Timeline",
              format: "pdf",
              source: "OH_EDPeer_Phase 1 High Level Implementation Timeline.pdf",
            },
            {
              label: "Phase 1 Implementation Calendar",
              format: "pdf",
              source: "OH_EDPeer_Phase 1 Implementation Calendar.pdf",
            },
          ]
        },
        {
          title: "Webinar Presentations",
          content: [
            {
              label: "Phase 2 Kickoff Implementation Webinar",
              format: "youtube",
              source: "xx8dyx7NFzc"
            },
            {
              label: "Phase 2 Kickoff Implementation Webinar (slides)",
              format: "pdf",
              source: "ED Peer-to-Peer Program Implementation Kick-off_February 2023.pdf"
            },
            {
              label: "Phase 2 Pre-Go-Live Touchpoint Presentation",
              format: "pdf",
              source: "OH_ED Peer_Pre-Go-Live Touchpoint_March_ 2023.pdf",
            },
            {
              label: "Clinical Introduction to ED Peer-to-Peer Program (slides)",
              format: "pdf",
              source: "OH_ED Peer_Clinician Introduction_March 2023.pdf"
            },
            {
              label: "Clinical Introduction to ED Peer-to-Peer Program (recording)",
              format: "youtube",
              source: "hReFHzvulOM"
            },
            {
              label: "Phase 2 Pre-Go-Live Touchpoint Recording",
              format: "youtube",
              source: "4gfbvR55g9E",
            },
            {
              format: "spacer",
              height: "1em"
            },
            {
              label: "Phase 1 Program Overview & Implementation Kick-off Presentation",
              format: "pdf",
              source: "ED Peer-to-Peer Program Phase 1 Implementation Kick-off.pdf",
            },
            {
              label: "Phase 1 Program Overview & Implementation Kick-off Recording",
              format: "youtube",
              source: "9OVlO3S4mZQ"
            },
            {
              label: "Preparing for Go-Live – Early Adopter Sites",
              format: "pdf",
              source: "3. OH_ED Peer-to-Peer Preparing for Go-Live+Operations_Sep 27-28 2022.pdf",
            },
          ],
        },
        {
          title: "Implementation Documents",
          content: [
            {
              label: "Site Implementation Guide",
              format: "pdf",
              source: "OH_EDPeer_Site Implementation Guide.pdf",
            },
            {
              label: "Site Profile Template",
              format: "doc",
              source: "OH_ED Peer Site Profile_Template.dotx"
            },
            {
              label: "Communications Toolkit",
              format: "zip",
              source: "Site Implementation Communications Toolkit.zip"
            },          
          ],
        },
      ],
    },
    sub2: {
      title: "Resources for ED Peer Physician",
      shorttitle: "ED Peer Physician",
      path: "/edpeer",
      breadcrumb: "<a href="+config.apiGateway.URL+"}></a> > ED Peer",
      format: "bucket",
      background: "/img/edpeer-heroimg.jpg",
      access: config.cognito.SUB2_SUB,
      sections: [
        {
          title: "ED Peer Shift Quick Links",
          content: [
            {
              label: "Site Contact List (OTN & Phone)",
              format: "pdf",
              source: "ED Peer Program OTN & Phone Hospital Site Contact List.pdf"
            },
            {
              label: "Daily Shift Summary",
              format: "xlsx",
              source: "OH_EDPeer Daily Shift Summary NO PHI 2024.02.12.xlsx"
            },
            {
              label: "Documentation Printable PDF Patient 20230321 V2",
              format: "pdf",
              source: "NEW_EDPeer documentation tool printable PDF PATIENT 20230321 V2.pdf"
            },
            {
              title: "Site Profiles",
              format: "subsection",
              content: [
                {
                  label: "Phase 2 Hospital Site Profiles (all)",
                  format: "zip",
                  source: "OH_EDPeer Phase Two Site Profiles 03.21.2023.zip",
                },
                {
                  label: "Phase 1 Hospital Site Profiles (all)",
                  format: "zip",
                  source: "Phase 1 Site Profiles (zip file).zip",
                },
                {
                  label: "Blanche River Health - Englehart",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_Blanche River Health - Englehart.pdf",
                },
                {
                  label: "Blanche River Health - Kirkland",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_Blanche River Health - Kirkland.pdf",
                },
                {
                  label: "Chapleau",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_Chapleau.pdf"
                },
                {
                  label: "Geraldton",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_Geraldton.pdf"
                },
                {
                  label: "Sioux Lookout Meno Ya Win Health Centre",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_Sioux Lookout Meno Ya Win Health Centre.pdf"
                },
                {
                  label: "WAHA Weeneebayko General Hospital",
                  format: "pdf",
                  source: "OH_ED Peer Site Profile_WAHA Weeneebayko General Hospital.pdf"
                },
              ]
            },
          ],
        },
        {
          title: "Webinar Presentations",
          content: [
            {
              title: "Onboarding Sessions",
              format: "subsection",
              content: [
                {
                  label: "ED Peer-to-Peer Program Physician Onboarding Session Recording",
                  format: "youtube",
                  source: "5ERJxIE1dbg"
                },{
                  label: "ED Peer-to-Peer Program Physician Onboarding Presentation",
                  format: "pdf",
                  source: "OH_EDPeer Remuneration Policy and Procedure_September 2022.pdf"
                },
              ]
            },
            {
              label: "Shiftboard Training",
              format: "youtube",
              source: "EFugrN1Hjx0"
            },{
              label: "VidyoConnect/EmergeServices Training",
              format: "youtube",
              source: "3ejFMXzXceI"
            }
          ],
        },
        {
          title: "Program Reference Documents",
          content: [
            {
              label: "ED Peer Physician Handbook",
              format: "pdf",
              source: "OH_EDPeer_Peer Physician Handbook.pdf",
            },
            {
              label: "ED Peer Physician Remuneration Policy and Procedure",
              format: "pdf",
              source: "OH_EDPeer Remuneration Policy and Procedure_September 2022.pdf",
            },
            {
              label: "ED Peer Scheduling Policy and Procedure",
              format: "pdf",
              source: "OH_EDPeer Scheduling Policy and Procedure.pdf",
            },
            {
              title: "Training",
              format: "subsection",
              content: [
                {
                  label: "MD Quick Reference Guide",
                  format: "pdf",
                  source: "EmergeServices Quick Reference Guide - ED Peer.pdf",
                },{
                  label: "Shiftboard Scheduling Application",
                  format: "pdf",
                  source: "Shiftboard Physician User Guide v1.pdf",
                },{
                  label: "EmergeServices Training Overview",
                  format: "pdf",
                  source: "EmergeServices Training Overview - ED Peer 2022.pdf",
                },{
                  label: "Virtual Critical Care Response Models",
                  format: "link",
                  source: "https://otn.ca/providers/emergency-services/virtual-critical-care/"
                },/*{
                  label: "Documentation Tool Training",
                  format: "youtube",
                  source: "fP8Qyfw8XAA",
                },*/
                {
                  label: "Shiftboard Training",
                  format: "youtube",
                  source: "EFugrN1Hjx0",
                },{
                  label: "VidyoConnect/EmergeServices Training",
                  format: "youtube",
                  source: "3ejFMXzXceI"
                }
              ]
            }
          ]
        },
        {
          title: "Sioux Lookout Documents",
          content: [
            {
              title: "Onboarding Materials",
              format: "subsection",
              content: [
                {
                  label: "Sioux Lookout Orientation Manual Community Medicine Jan 2024",
                  format: "pdf",
                  source: "Sioux Lookout Orientation Manual Community Medicine Jan 2024.pdf",
                },{
                  label: "SLKT Regional Norms of Practice V October202020",
                  format: "pdf",
                  source: "SLKT Regional Norms of Practice V October202020.pdf",
                },
              ]
            },
            {
              title: "Orientation Videos",
              format: "subsection",
              content: [
                {
                  label: "Vimeo Orientation Videos",
                  desc: "Password to view these videos is: SLFNHA",
                  format: "link",
                  source: "https://vimeo.com/showcase/9767854",
                }
              ]
            },
            {
              title: "OSCAR EMR Files",
              format: "subsection",
              content: [
                {
                  label: "Appointment Screen Overview",
                  format: "pdf",
                  source: "Appt Screen Overview.pdf",
                },
                {
                  label: "Chart Note",
                  format: "pdf",
                  source: "Chart Note OSCAR.pdf",
                },
                {
                  label: "Community Prescriptions",
                  format: "pdf",
                  source: "OSCAR Prescriptions.pdf",
                },
                {
                  label: "OSCAR Cheat Notes",
                  format: "pdf",
                  source: "Sioux Lookout OSCAR cheat notes.pdf",
                }
              ]
            },
            {
              title: "Supporting / Reference Documents",
              format: "subsection",
              content: [
                {
                  label: "Supporting / Reference Documents",
                  format: "link",
                  source: "https://drive.google.com/drive/folders/1qiD6iquNEBoz8b04gp80pK55ticVKzbG",
                },
                {
                  label: "Discharges for Patient When Consult Complete",
                  format: "doc",
                  source: "Discharges for Patient when Consult Complete.docx",
                },
                {
                  label: "Nursing Station Phone Numbers",
                  format: "pdf",
                  source: "ISC - Nursing Stations Phone Numbers_08 Mar 2021.pdf",
                },
                {
                  label: "Northern Community Map",
                  format: "pdf",
                  source: "Northern Community map .pdf",
                },
                {
                  label: "Pharmacy-Community List",
                  format: "pdf",
                  source: "Pharmacy contact list Feb 2024.pdf",
                },
                {
                  label: "Use of Social Media Policy",
                  format: "pdf",
                  source: "Use of Social Media Policy 2021.09.pdf",
                },
                {
                  label: "Nursing Station Formulary",
                  format: "pdf",
                  source: "VFinal Formulary February 23 2023 WITHOUT Treatment Codes.pdf",
                },
                {
                  label: "Crash Cart and ER Checklist",
                  format: "doc",
                  source: "Appendix F Crash Cart and ER Checklist ACLS PALS November 13 2020.docx",
                },
              ]
            },
            {
              title: "Privacy-Related Materials",
              format: "subsection",
              content: [
                {
                  label: "Physician, Resident, Student, Locum Oath of Confidentiality",
                  format: "pdf",
                  source: "Physician, Resident, Student, Locum Oath of Confidentiality.pdf",
                },
                {
                  label: "Privacy and Confidentiality Working From Home Agreement",
                  format: "pdf",
                  source: "Privacy and Confidentiality Working From Home Agreement.pdf",
                },
                {
                  label: "SLFNHA - Privacy Code of Conduct Policy",
                  format: "pdf",
                  source: "SLFNHA - Privacy Code of Conduct Policy.pdf",
                },
                {
                  label: "SLFNHA - Privacy Policies and Procedures (Revised Feb 28 2019)",
                  format: "pdf",
                  source: "SLFNHA - Privacy Policies and Procedures (Revised Feb 28 2019).pdf",
                },
              ]
            },
            {
              title: "Indigenous Relationship and Cultural Awareness Courses",
              format: "subsection",
              content: [
                {
                  label: "Indigenous Relationship and Cultural Awareness Courses",
                  format: "link",
                  source: "https://elearning.ontariohealth.ca/course/index.php?categoryid=20",
                },
              ]
            },
          ]
        },
      ],
    },
    resourcelibrary: {
      title: "Resource Library",
      path: "/resources",
      breadcrumb: "Home > Resource Library",
      desc: "This page will host clinical resources submitted by clinicians to support knowledge sharing related to Emergency Medicine best practices.",
      format: "bucket",
      background: "/img/edpeer-heroimg.jpg",
      access: [config.cognito.SUB1_SUB,config.cognito.SUB2_SUB],
      sections: [
        {
          title: "",
          content: [
            {
              label: "",
              format: "",
              source: "",
            },
          ],
        },
      ],
    },
  }
  :
  config.TITLE === 'ReCaptcha' ? {
    home: {
      title: "Recaptcha",
      path: "/",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      desc: "<p>Let's test Recaptcha</p>",
      sections: [
        {
          title: "",
          format: "portal",
          content: [
            {
              format: "card",
              flex: false,
              access: config.cognito.SUB1_SUB,
              label: "Title 1",
              desc: "<p>Forms, OHIP information, schedules, and other documents</p>",
              source: "/sub1",
            },
            {
              format: "card",
              flex: false,
              access: config.cognito.SUB2_SUB,
              label: "Title 2",
              desc: "<p>Forms, site information and workflows</p>",
              source: "/sub2",
            },
          ],
        },
        {
          title: "Getting Started",
          content: [
            {
              label: "Public document",
              format: "pdf",
              source:
                "/resources/public/public.pdf",
            },
          ],
        },
      ],
    },
    sub1: {
      title: "Subscriber 1",
      shorttitle: "Sub1",
      breadcrumb: "<a href="+config.apiGateway.URL+"}></a> > ED Site",
      path: "/sub1",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      access: config.cognito.SUB1_SUB,
      sections: [
        {
          title: "Documents for Sub 1",
          content: [
            {
              label: "Shared private document",
              format: "pdf",
              access: "shared",
              source: "shared.pdf",
            },
            {
              label: "Document for sub 1 only",
              format: "pdf",
              source: "private_sub1.pdf",
            },
            {
              label: "Public document",
              format: "pdf",
              access: "public",
              source: "public.pdf",
            },
          ],
        },
      ],
    },
    sub2: {
      title: "Subscriber 2",
      shorttitle: "Sub2",
      breadcrumb: "<a href="+config.apiGateway.URL+"}></a> > ED Site",
      path: "/sub2",
      format: "bucket",
      background: "/img/telestroke-heroimg.jpg",
      access: config.cognito.SUB2_SUB,
      sections: [
        {
          title: "Documents for Sub 2",
          content: [
            {
              label: "Shared private document",
              format: "pdf",
              access: "shared",
              source: "shared.pdf",
            },
            {
              label: "Document for sub 2 only",
              format: "pdf",
              source: "private_sub2.pdf",
            },
            {
              label: "Public document",
              format: "pdf",
              access: "public",
              source: "public.pdf",
            },
          ],
        },
      ],
    },
  }
  :
  {}

export default resourceMap;
